import { all, call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/datasources/editJobLoad';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

// A failed re-introspection must not sink the editor (mirrors the old
// `.catch(() => null)`): the lightweight editor still works without tables.
function* safeInspect(sourceId, headers) {
  try {
    return yield call(
      axios.post,
      `${config.API_URL}/ingestion/connect/inspect-source/${sourceId}`,
      {},
      { headers },
    );
  } catch (e) {
    return null;
  }
}

// Load everything the sync editor needs in parallel: the source's jobs list
// and a fresh introspection of the source schema.
function* operation(action) {
  const { sourceId } = action.payload;
  try {
    const headers = getLocalUser();
    const [jobsRes, inspRes] = yield all([
      call(axios.get, `${config.API_URL}/ingestion/jobs`, { headers, params: { source_id: sourceId, per_page: 200 } }),
      call(safeInspect, sourceId, headers),
    ]);
    const jobs = (jobsRes.data?.data || jobsRes.data)?.jobs || [];
    const inspect = inspRes ? (inspRes.data?.data || inspRes.data) : null;
    yield put(fetchSuccess({ jobs, inspect }));
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchFailure(error.response?.data?.error || error.message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
